import React from "react";
import ReactECharts from "echarts-for-react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MDBox from "components/MDBox";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const ViewGraficoProcesos = (props: any) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <MDBox sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Métricas CPU" {...a11yProps(0)} />
          <Tab label="Métricas Memoria" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <StackedBarChart categories={props.categories} series={props.series} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <StackedBarChart categories={props.categories} series={props.seriesRam} />
      </CustomTabPanel>
    </MDBox>
  );
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function StackedBarChart(props: any) {
  const { categories, series } = props;

  const formattedCategories = categories.map((timestamp: number) =>
    new Date(timestamp).toLocaleTimeString("es-CO", {
      hour: "2-digit",
      minute: "2-digit",
    })
  );

  const seriesFinal = series.map((s: any) => ({
    name: s.name,
    type: "bar",
    stack: "total",
    barWidth: 70,
    label: {
      show: true,
      position: "inside",
      fontSize: 11,
      formatter: (params: any) => (params.value > 0 ? `${params.value.toFixed(1)}%` : ""),
    },
    data: s.data,
  }));

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: (params: any) =>
        params
          .filter((p: any) => p.value > 0)
          .map((p: any) => `${p.seriesName}: ${p.value.toFixed(2)}%`)
          .join("<br/>"),
    },
    legend: { top: 10 },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "8%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: formattedCategories,
      axisLabel: {
        rotate: 45,
      },
    },
    yAxis: {
      type: "value",
      max: 100,
      axisLabel: {
        formatter: "{value}%",
      },
    },
    series: seriesFinal,
  };

  return <ReactECharts option={option} style={{ width: "400%", height: 420 }} notMerge={true} />;
}

export default ViewGraficoProcesos;
